export default __webpack_public_path__ + "locales/bg/People.json?hash=c7c87da8d7b87c0f0dfa5a27509225fa";